<template>
  <header id="header">
    <h1 class="logo">
      {{ logoAlt }}
    </h1>

    <div class="header__perg">
      <h2
        class="header__perg__dia"
        :style="stylesDataDia"
      >
        {{ dataDia }}
      </h2>

      <p
        class="header__perg__mes"
        :style="stylesDataMes"
      >
        de {{ dataMes }}
      </p>

      <p
        class="header__perg__horario"
        :style="stylesHora"
      >
        das {{ horaInicio }} às {{ horaFim }}
      </p>

      <p
        class="header__perg__local"
        :style="stylesLocal"
      >
        {{ localLocal }}
      </p>
      
      <p
        class="header__perg__local-especifico"
        :style="stylesLocalEspecifico"
      >
        {{ localEspecifico }}
        <br />
        {{ localCidade }} - {{ localEstado }}
      </p>
    </div>

    <nav>
      <ul>
        <li
          v-for="link in menu"
          :key="link.key"
          :style="stylesMenu"
        >
          <a
            :href="link.url"
            :target="link.target"
            v-smooth-scroll
          >
            {{ link.text }}
          </a>
        </li>
      </ul>
    </nav>

    <div class="header__passaro"></div>

    <div class="header__ondas-1"></div>
    <div class="header__ondas-2"></div>

    <div class="header__nuvens-1"></div>

    <div class="header__sereia"></div>
    <div class="header__navio"></div>

    <div class="header__ondas-3"></div>
    <div class="header__ondas-4"></div>

    <div class="header__nuvens-2"></div>
    <div class="header__nuvens-3"></div>
    <div class="header__nuvens-4"></div>

    <div class="header__ilha"></div>
    <div class="header__ceu"></div>
  </header>
</template>

<script>
  export default {
    name: 'Header',
    
    props: [
      'logoAlt',

      'dataDia',
      'dataMes',

      'horaInicio',
      'horaFim',

      'localPais',
      'localEstado',
      'localCidade',
      'localLocal',
      'localEspecifico',

      'menu',

      'stylesMenu',

      'stylesDataDia',
      'stylesDataMes',

      'stylesHora',

      'stylesLocal',
      'stylesLocalEspecifico',
    ],
  }
</script>

<style scoped lang="scss">
  /* Sizes */
  $baseWidth: 1150px;

  /* Variables */
  $red: #990000;

  /* Placeholders */
  %ease-infinite {
    animation-timing-function: ease;
    animation-iteration-count: infinite;
  }
  %linear-infinite {
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }

  header, .header {
    width: 100%;
    height: 400px;

    overflow: hidden;

    background: url('./../images/header/ceu.jpg') repeat-y;

    @media (max-width: 1000px) {
      background: url('./../images/header/topo-resp.jpg') repeat-y;
      background-position: top right;
    }

    .logo {
      background: url('./../images/header/logo.gif') no-repeat;

      width: 510px;
      height: 250px;

      position: absolute;
      z-index: 500;

      top: 20px;
      left: 40px;

      text-indent: -9999px;
      overflow: hidden;
      display: block;

      @media (max-width: 560px) {
        width: 320px;
        height: 200px;

        background-size: contain;

        top: 10px;
        left: 10px;
      }
    }
    &__perg {
      background: url('./../images/header/perg.png') no-repeat;

      padding: 20px 100px 0 40px;
      margin: 70px 0 40px 0;

      width: 520px;
      height: 300px;

      font-family: 'Gochi Hand', cursive;
      color: $red;
      letter-spacing: 1px;

      position: absolute;
      display: block;
      z-index: 490;

      top: 240px;
      left: 40px;

      @media (max-width: 560px) {
        width: 320px;
        padding: 25px 60px 0 15px;
        margin: 15px 0 20px 0;

        background-size: contain;

        top: 200px;
        left: 20px;
      }

      &__dia {
        font-size: 85px;
        font-weight: bolder;

        float: left;

        margin: 20px 15px 40px 0;

        @media (max-width: 560px) {
          font-size: 50px;
          margin: 20px 15px 20px 0;
        }
      }

      &__mes {
        margin-top: 30px;

        font-size: 32px;
        font-weight: bolder;

        float: left;

        @media (max-width: 560px) { font-size: 20px; }
      }
      &__horario {
        font-size: 19px;
        font-weight: bold;

        float: left;

        margin: 10px 0 0 0;

        @media (max-width: 560px) {
          font-size: 14px;
        }
      }
      &__local {
        font-size: 16px;
        font-weight: bold;

        float: left;

        &-especifico {
          font-size: 17px;

          float: left;
          margin: 15px 0 0 0;

          @media (max-width: 560px) {
            margin: 5px 0 0 0;
            font-size: 10px;
          }
        }
      }
    }

    nav {
      transform: rotate(3deg);
      background: url('./../images/header/menu-bg.png') no-repeat;
      background-size: contain;

      width: 600px;
      height: 150px;

      position: absolute;
      z-index: 480;

      top: 470px;
      left: 630px;

      @media (max-width: 1200px) {
        display: none;
      }

      ul {
        margin: 5px 65px 0 5px;
        text-align: center;

        li {
          display: inline-block;
          padding: 5px;

          font-family: 'Gochi Hand', cursive;
          font-weight: bolder;

          color: rgba(0,0,0,0.6);
          text-shadow: 2px 2px 3px rgba(255,255,255,0.1);

          letter-spacing: 3px;

          font-size: 20px;
          line-height: 20px;

          &:before {
            display: none;
          }

          a {
            color: rgba(0,0,0,0.6);
            text-shadow: 2px 2px 3px rgba(255,255,255,0.1);

            line-height: 22px;
            letter-spacing: 1px;

            text-decoration: none;
            text-transform: uppercase;

            border-bottom: 3px solid rgba(0,0,0,0.6);

            &:hover {
              color: #FFFFFF;
              border-bottom: 3px solid #FFFFFF;
            }
          }
        }
      }
    }

    &__passaro, &__ilha, &__sereia, &__navio,
    &__ondas-1, &__ondas-2, &__ondas-3, &__ondas-4,
    &__nuvens-1, &__nuvens-2, &__nuvens-3, &__nuvens-4 {
      @media (max-width: 1000px) { display: none; }
    }

    &__passaro  { z-index: 120; }
    &__ondas-1  { z-index: 110; }
    &__ondas-2  { z-index: 100; }
    &__nuvens-1 { z-index: 90; }
    &__sereia   { z-index: 80; }
    &__navio    { z-index: 70; }
    &__ondas-3  { z-index: 60; }
    &__ondas-4  { z-index: 50; }
    &__ilha     { z-index: 40; }
    &__nuvens-2 { z-index: 30; }
    &__nuvens-3 { z-index: 20; }
    &__nuvens-4 { z-index: 10; }
    &__ceu      { z-index: 0; }

    &__ondas-1, &__ondas-2, &__ondas-3, &__ondas-4 {
      width: 2000px;
      height: 120px;

      position: absolute;
      opacity: 0.5;
    }

    &__ondas-1 {
      background: url('./../images/header/ondas-1.gif') no-repeat;

      top: 400px;
      left: calc(50% - 1000px);

      animation-name: anm-onda-1;
      animation-duration: 10s;
      @extend %ease-infinite;

      @keyframes anm-onda-1 {
        0%   {top: 400px; transform: rotate(1deg);}
        25%  {top: 420px; transform: rotate(-1deg);}
        50%  {top: 400px; transform: rotate(1deg);}
        75%  {top: 380px; transform: rotate(-1deg);}
        100% {top: 400px; transform: rotate(1deg);}
      }
    }
    &__ondas-2 {
      background: url('./../images/header/ondas-2.gif') no-repeat;
      left: calc(50% - 1000px);

      animation-name: anm-onda-2;
      animation-duration: 10s;
      @extend %ease-infinite;

      @keyframes anm-onda-2 {
        0%   {top: 380px; transform: rotate(1deg);}
        20%  {top: 400px; transform: rotate(-1deg);}
        40%  {top: 380px; transform: rotate(1deg);}
        60%  {top: 400px; transform: rotate(-1deg);}
        80%  {top: 390px; transform: rotate(-2deg);}
        100% {top: 380px; transform: rotate(1deg);}
      }
    }
    &__ondas-3 {
      background: url('./../images/header/ondas-3.gif') no-repeat;
      left: calc(50% - 1000px);

      animation-name: anm-onda-3;
      animation-duration: 20s;
      @extend %ease-infinite;

      @keyframes anm-onda-3 {
        0%   {top: 360px; transform: rotate(1deg);}
        10%  {top: 380px; transform: rotate(-1deg);}
        20%  {top: 360px; transform: rotate(1deg);}
        30%  {top: 340px; transform: rotate(-1deg);}
        40%  {top: 360px; transform: rotate(1deg);}
        50%  {top: 380px; transform: rotate(-1deg);}
        60%  {top: 360px; transform: rotate(1deg);}
        70%  {top: 340px; transform: rotate(-1deg);}
        80%  {top: 360px; transform: rotate(1deg);}
        90%  {top: 380px; transform: rotate(-1deg);}
        100% {top: 360px; transform: rotate(1deg);}
      }
    }
    &__ondas-4 {
      background: url('./../images/header/ondas-4.gif') no-repeat;
      left: calc(50% - 1000px);

      animation-name: anm-onda-4;
      animation-duration: 30s;
      @extend %ease-infinite;

      @keyframes anm-onda-4 {
        0%   {top: 340px; transform: rotate(1deg);}
        5%   {top: 360px; transform: rotate(-1deg);}
        10%  {top: 340px; transform: rotate(1deg);}
        15%  {top: 320px; transform: rotate(-1deg);}
        20%  {top: 340px; transform: rotate(1deg);}
        25%  {top: 360px; transform: rotate(-1deg);}
        30%  {top: 340px; transform: rotate(1deg);}
        35%  {top: 320px; transform: rotate(-1deg);}
        40%  {top: 340px; transform: rotate(1deg);}
        45%  {top: 360px; transform: rotate(-1deg);}
        50%  {top: 340px; transform: rotate(1deg);}
        55%  {top: 320px; transform: rotate(-1deg);}
        60%  {top: 340px; transform: rotate(1deg);}
        65%  {top: 360px; transform: rotate(-1deg);}
        70%  {top: 340px; transform: rotate(1deg);}
        75%  {top: 320px; transform: rotate(-1deg);}
        80%  {top: 340px; transform: rotate(1deg);}
        85%  {top: 360px; transform: rotate(-1deg);}
        90%  {top: 340px; transform: rotate(1deg);}
        95%  {top: 320px; transform: rotate(-1deg);}
        100% {top: 340px; transform: rotate(1deg);}
      }
    }

    &__sereia {
      background: url('./../images/header/sereia.gif') no-repeat;

      width: 100px;
      height: 30px;

      top: 440px;

      position: absolute;

      animation-name: anm-sereia;
      animation-duration: 300s;
      @extend %linear-infinite;

      @keyframes anm-sereia {
        0% {left: -10%}
        100% {left: 110%}
      }
    }

    &__navio {
      background: url('./../images/header/navio.gif');

      width: 600px;
      height: 400px;

      position: absolute;
      right: 0;

      animation-name: anm-navio;
      animation-duration: 60s;
      @extend %ease-infinite;

      @keyframes anm-navio {
        0%   {top: 15px; transform: rotate(-2deg);}
        5%   {top: 30px; transform: rotate(2deg);}
        10%  {top: 15px; transform: rotate(-2deg);}
        15%  {top: 25px; transform: rotate(2deg);}
        20%  {top: 15px; transform: rotate(-2deg);}
        25%  {top: 30px; transform: rotate(2deg);}
        30%  {top: 15px; transform: rotate(-2deg);}
        35%  {top: 25px; transform: rotate(2deg);}
        40%  {top: 15px; transform: rotate(-2deg);}
        45%  {top: 30px; transform: rotate(2deg);}
        50%  {top: 15px; transform: rotate(-2deg);}
        55%  {top: 25px; transform: rotate(2deg);}
        60%  {top: 15px; transform: rotate(-2deg);}
        65%  {top: 30px; transform: rotate(2deg);}
        70%  {top: 15px; transform: rotate(-2deg);}
        75%  {top: 25px; transform: rotate(2deg);}
        80%  {top: 15px; transform: rotate(-2deg);}
        85%  {top: 30px; transform: rotate(2deg);}
        90%  {top: 15px; transform: rotate(-2deg);}
        95%  {top: 25px; transform: rotate(2deg);}
        100% {top: 15px; transform: rotate(-2deg);}
      }
    }

    &__nuvens-1, &__nuvens-2, &__nuvens-3, &__nuvens-4 {
      width: 2000px;
      height: 300px;

      top: 0;

      position: absolute;
      opacity: 0.5;
    }

    &__nuvens-1 {
      background: url('./../images/header/nuvens-1.png') repeat;

      animation-name: anm-nuvens-1;
      animation-duration: 80s;
      @extend %linear-infinite;

      @keyframes anm-nuvens-1 {
        0%   {left: -100%}
        100% {left: 100%}
      }
    }
    &__nuvens-2 {
      background: url('./../images/header/nuvens-2.png') repeat;

      animation-name: anm-nuvens-2;
      animation-duration: 90s;
      @extend %linear-infinite;

      @keyframes anm-nuvens-2 {
        0% {left: -100%}
        100% {left: 100%}
      }
    }
    &__nuvens-3 {
      background: url('./../images/header/nuvens-3.png') repeat;

      animation-name: anm-nuvens-3;
      animation-duration: 100s;
      @extend %linear-infinite;

      @keyframes anm-nuvens-3 {
        0% {left: -100%}
        100% {left: 100%}
      }
    }
    &__nuvens-4 {
      background: url('./../images/header/nuvens-4.png') repeat;

      animation-name: anm-nuvens-4;
      animation-duration: 110s;
      @extend %linear-infinite;

      @keyframes anm-nuvens-4 {
        0% {left: -100%}
        100% {left: 100%}
      }
    }

    &__ilha {
      background: url('./../images/header/ilha.png') no-repeat;

      width: 150px;
      height: 150px;

      top: 200px;

      position: absolute;

      animation-name: anm-ilha;
      animation-duration: 600s;
      @extend %linear-infinite;

      @keyframes anm-ilha {
        0% {right: -10%}
        100% {right: 100%}
      }
    }

    &__passaro {
      background: url('./../images/header/passaro.gif') no-repeat;
      background-size: contain;

      width: 150px;
      height: 150px;

      position: absolute;

      animation-name: anm-passaro;
      animation-duration: 120s;
      animation-timing-function: ease-in;
      animation-iteration-count: infinite;

      @keyframes anm-passaro {
        0% {left: -5%; top: -5px; width: 10px; height: 10px; }
        100% {left: 150%; top: 150px; width: 150px; height: 150px; }
      }
    }

    &__ceu {
      background: url('./../images/header/ceu.jpg') repeat;
    }
  }
</style>
